export const COORDINATE_SYSTEMS = {
  dd: 'decimal-degrees',
  dms: 'degrees-minutes-seconds',
  mgrs: 'military-grid-reference-system',
} as const;

export type CoordinateSystem =
  (typeof COORDINATE_SYSTEMS)[keyof typeof COORDINATE_SYSTEMS];
